/**
 * `<PageBody>` — the scrollable region below `<PageHead>` (Phase 2 of the UI
 * overhaul). Default padding is 24×32 per the design spec; `flush` removes the
 * padding for surfaces that own their own internal scrolling (graph, chat,
 * editor multi-pane layouts).
 *
 * Pairs with `<PageHead>` inside the `.main` slot of `<AppShell>`.
 */

import type { ReactNode } from 'react';

interface PageBodyProps {
  children: ReactNode;
  /** When true, drops the default 24×32 padding. Use for surfaces that handle
   *  their own internal scroll/layout (graph, chat, editor split-pane). */
  flush?: boolean;
  /** Optional extra class — surfaces can extend the body container without
   *  wrapping it in another scroll context. */
  className?: string;
}

export function PageBody({ children, flush = false, className = '' }: PageBodyProps): JSX.Element {
  return (
    <div className={`page-body${flush ? ' flush' : ''} ${className}`.trim()}>
      {children}
    </div>
  );
}
